export enum AuthFlowType {
  CREDENTIALS = 'credentials',
  SITE_CREDENTIALS = 'site-credentials',
}

export enum FlowType {
  LOGIN = 'login',
  RECONSENT = 're_consent',
}

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  type: FlowType,
  labels: {
    headerTitle: string;
    headerSubtitle: string;
    input: string;
    inputAria: {
      required: string;
    }
    nextButton: string;
    nextButtonAria: {
      enabled: string;
      disabled: string;
    }
  },
  skipStep: boolean,
  backSteps: number;
  canCreateCard: boolean;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.CREDENTIALS]: {
    form: "validate_password__" + AuthFlowType.CREDENTIALS,
    flow: AuthFlowType.CREDENTIALS,
    type: FlowType.LOGIN,
    labels: {
      headerTitle: "consent.decline_confirmation.title",
      headerSubtitle: "consent.decline_confirmation.subtitle",
      input: 'card_association.card_number_input',
      inputAria: {
        required: 'accessibility.loyaltycard.loyalty_card_association.input',
      },
      nextButton: 'card_association.button_next_message',
      nextButtonAria: {
        enabled: "accessibility.loyaltycard.loyalty_card_association.button.submit",
        disabled: "accessibility.loyaltycard.loyalty_card_association.button.cant_submit",
      }
    },
    backSteps: 0,
    skipStep: false,
    canCreateCard: true
  },
  [AuthFlowType.SITE_CREDENTIALS]: {
    form: "validate_password__" + AuthFlowType.SITE_CREDENTIALS,
    flow: AuthFlowType.SITE_CREDENTIALS,
    type: FlowType.RECONSENT,
    labels: {
      headerTitle: "consent.title",
      headerSubtitle: "consent.subtitle_re_consent",
      input: 'site_credentials.loyaltycard_association.definition.card_number_input',
      inputAria: {
        required: 'accessibility.loyaltycard.loyalty_card_association.input',
      },
      nextButton: 'site_credentials.button_next_message',
      nextButtonAria: {
        enabled: "site_credentials.button_next_message",
        disabled: "site_credentials.button_next_message",
      }
    },
    skipStep: true,
    backSteps: 1,
    canCreateCard: true
  }
}